module.exports = __webpack_public_path__ + "static/media/viewOnlyAccess.2004c898.svg";